import { DocumentApi } from "../openapi";
import openApiConfig from "./http_service";

const documentApi=new DocumentApi(openApiConfig)

export default documentApi